import { SearchItem } from '@cube3/cubicle/src/core/molecules/SearchItem';
import { HBox } from '@cube3/cubicle/src/core/templates/layout/Flex';
import { getNodeDisplayImageSrc } from '@cube3/ui/src/human/nodeDisplayImageResolver';
import { capitalize } from '@material-ui/core';
import React, { useCallback, useMemo } from 'react';
import {
  MeiliHighlight,
  SearchHit
} from '../../Search/CommandKMenu/prefabs/SearchHit';
import { useFileRequestBreadcrumbs } from '../../FileRequest/hooks/useFileRequestCrumbs';
import { useHistory } from 'react-router-dom';
import { PublicResource } from '@cube3/common/model/resource-types';
import { useGenerativeContext } from '../contexts/GenerativeContext';
import { useModalActions } from '../../Modals/modalActions';
import { Checkbox } from '@cube3/cubicle/src/core/atoms/Checkbox/Checkbox';
import { SizeVariants } from '@cube3/cubicle/src/theme/themes';

export interface SearchResultItemProps {
  /** api resource to get thumbnail and hit info from  */
  resource: PublicResource & {
    meta?: { highlight?: MeiliHighlight };
  };
  /** string being searched for */
  query: string;
  disableNavigation?: boolean;
}

export const SearchResultItem = ({ disableNavigation = false, resource, query }: SearchResultItemProps) => {
  const { setSelections, isAssetSelected, canSelectMore } =
    useGenerativeContext();

  const { previousModal } = useModalActions();
  const { crumbs } = useFileRequestBreadcrumbs({
    nodeId: resource.id,
    type: resource.type
  });

  const onClick = useCallback(
    (e) => {
      e?.stopPropagation?.();
      setSelections?.(resource);
    },
    [resource, setSelections]
  );

  const history = useHistory();
  const parsedCrumbs = useMemo(() => {
    return crumbs?.map((c) => ({
      title: c.name,
      url: c.pathname,
      onClick: disableNavigation ? () => null : () => {
        previousModal();
        history.push(c.pathname);
      }
    }));
  }, [crumbs, disableNavigation]);

  const thumbnail = getNodeDisplayImageSrc(resource);

  const isSelected = isAssetSelected(resource);

  const disabled = !canSelectMore && !isSelected;
  return (
    <HBox
      key={resource.id}
      style={{ gap: 8 }}
      align="center"
      onClick={disabled ? undefined : onClick}
    >
      <Checkbox
        value={isSelected}
        disabled={disabled}
        size={SizeVariants.md}
        onChange={onClick}
      />
      <SearchItem
        title={resource.display_name}
        thumbnailSrc={thumbnail}
        breadcrumbs={
          resource &&
            (resource.type === 'project' || resource.type === 'contract')
            ? capitalize(resource.type)
            : parsedCrumbs
        }
        active={isSelected}
      >
        {resource?.meta?.highlight ? (
          <SearchHit hitObject={resource.meta.highlight} query={query} />
        ) : null}
      </SearchItem>
    </HBox>
  );
};
